<ng-container *transloco="let t">
    <div [dir]="lang==='en'?'ltr':'rtl'" class="flex justify-center items-center text-2xl">
        <img class="dark:hidden w-26 h-26 rounded-full object-contain" src="../../../../../../../../../assets/images/logo/logo-text.png"
            alt="">
        <img class="hidden dark:inline w-26 h-26 rounded-full object-contain" src="../../../../../../../../../assets/images/logo/logo-text-dark.png"
            alt="">
    </div>
    <h1 class="text-2xl text-center -mt-2 mb-1 font-semibold">{{data.title}}</h1>
    <p class="text-lg text-center mb-8" [innerHTML]="data.message">
      
    </p>

</ng-container>